import { Injectable } from '@angular/core';
import Widget, { component, configuration, journey } from '../widget/index.js';
import { UtilsService } from './utils.service';
import { WidgetConfigOptions } from '../widget';
import { environment } from '../../environments/environment.js';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Observable } from 'rxjs';
const myConfig = configuration();

@Injectable({
  providedIn: 'root',
})
export class WidgetService {
  constructor(public utilsSrv: UtilsService, private http: HttpClient) {
    this.init();
  }

   init() {
    myConfig.set(this.getWidgetConfig);
  }
  setWidget(journeyName: string) {
    const url = new URL(location.href);
    const codeParam = url.searchParams.get('code');
    const stateParam = url.searchParams.get('state');
    const formPostEntryParam = url.searchParams.get('form_post_entry');

    // Get the element in your HTML into which you will mount the widget
    const widgetRootEl = document.getElementById('widget-root');
    if (!widgetRootEl) return;
    // Instantiate Widget with the `new` keyword
    new Widget({
      target: widgetRootEl, // Any existing element from static HTML file
      props: {
        type: 'inline', // Override the default 'modal' form factor
      },
        
      
      
    });
    // Assign the journey function
    const journeyEvents = journey({ oauth: false, user: false });

    // Ensure you call `.start` *AFTER* instantiating the Widget
    console.log('variables')
    console.log(journeyName)
    console.log(location.href)
    if (formPostEntryParam || (codeParam && stateParam)) {
      journeyEvents.start({ journey: journeyName, resumeUrl: location.href });
      console.log('internal users');
      //journeyEvents.subscribe((res) => console.log);
    } else {
      journeyEvents.start({ journey: journeyName });
      console.log('internal else');
    }

    // Assign the component function
    const componentEvents = component();
    componentEvents.open();
    return journeyEvents;
  }
  get getWidgetConfig(): WidgetConfigOptions {
    return {
      content: {
        userName: 'Identifier',
        passwordCallback: ' ',
        nextButton: 'Next',
      },
      links: {
        termsAndConditions: environment.tyc
      },
      forgerock: {
        // Minimum required configuration:
        serverConfig: {
          baseUrl: environment.baseUrlPing,
          timeout: 9000,
        },
        // Optional configuration:
        clientId: environment.clientId, // The default is `WebLoginWidgetClient`
        realmPath: environment.realmPath, // This is the default if not specified
        redirectUri: `${this.utilsSrv.getDomain}/callback` /* window.location.href */, // This is the default if not specified
        scope: environment.scope,
      }
    };
  }

  getSession(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-API-Version':'resource=4.0, protocol=1.0'
    })
    return this.http.get<any>( environment.apiURL + '/api/validate', 
      {headers, withCredentials: true})
  }
  getSessionReal() {
  }
}